module.exports = __webpack_public_path__ + "static/media/about-people.e418a781.png";